import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CssBaseline, useMediaQuery, useTheme } from "@mui/material";
import EnrollFrame from "../../elements/EnrollFrame";
import HeroSection from "../../elements/HeroSection";
import NutritionFrame from "./NutritionFrame";
import SparrowSection from "./SparrowSection";

const ApproachPage: React.FC = () => {
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CssBaseline />
      <HeroSection
        mainTitle={<>{t("ApproachPage.mainTitle")}</>}
        secondaryTitle={t("ApproachPage.secondaryTitle")}
        backgroundImageUrl={"/approachPage/hero.webp"}
        altImage={t("AltImages.alt_image_approach")}
        buttonText={t("ApproachPage.buttonText")}
        buttonOnClickPath={"enroll"}
        isApproachPage={true}
      />
      <SparrowSection
        image="/birds/blue.webp"
        title1={t("ApproachPage.SparrowSection.Section1.title_1")}
        description1={t("ApproachPage.SparrowSection.Section1.description_1")}
        description2={t("ApproachPage.SparrowSection.Section1.description_2")}
        marginTop={true}
      />
      <SparrowSection
        image="/ApproachPage/kinder7.webp"
        title1={t("ApproachPage.SparrowSection.Section2.title_1")}
        description1={t("ApproachPage.SparrowSection.Section2.description_1")}
        description2={t("ApproachPage.SparrowSection.Section2.description_2")}
        title3={t("ApproachPage.SparrowSection.Section2.title_3")}
        reverse={true}
        marginTop={isMobile ? false : true}
      />
      <NutritionFrame />
      <SparrowSection
        image="/birds/yellow.webp"
        title1={t("ApproachPage.SparrowSection.Section3.title_1")}
        description1={t("ApproachPage.SparrowSection.Section3.description_1")}
        title2={t("ApproachPage.SparrowSection.Section3.title_2")}
        description2={t("ApproachPage.SparrowSection.Section3.description_2")}
        reverse={true}
        marginTop={true}
        marginBottom={true}
      />
      <EnrollFrame />
    </>
  );
};

export default ApproachPage;
